export const TEST_ID = 'layout';

export const DESKTOP = 'desktop';
